import { registerFeatureMessages, type SupportedLocale } from '@/shared/i18n'

export function registerCreativeAiMessages(locale: SupportedLocale): Promise<void> {
  return registerFeatureMessages('creativeAi', locale)
}
